module.exports = __webpack_public_path__ + "img/T6-C-rc_10.69d72f22.png";